export default "/images/vendor/flag-icon-css/flags/4x3/my.svg?0d298a9e4566332f8a840d388fa6db2d";